import {
  InjectionKey,
  inject,
  provide,
  shallowRef,
  computed,
  readonly,
  onScopeDispose,
  DeepReadonly,
  ComputedRef,
  ShallowRef,
  getCurrentInstance,
  AppContext
} from "vue";
import {
  Dispatch,
  isReduxStore,
  ReduxStore,
  State,
  StateStoreLike,
  StateStore,
  ValueUpdater
} from "@zyzgroup/core-common";

type AppStoreContextValue<T extends State> = {
  store: StateStore<T>;
  stateRef: ShallowRef<T>;
};

// type AppState = {
//   user: {
//     name: string;
//     age: number;
//   };
// };
// export const { provideAppStore, useAppState, useSetAppState, useDispatch } = createAppStoreContext<AppState>(store);
// setup() {
//  provideAppStore();
// }
// setup() {
//  const appState = useAppState();
//  const user = useAppState((s) => s.user);
//  const name = useAppState((s) => s.user.name);
//  const dispatch = useDispatch();
// }

export function createAppStoreContext<T extends State>(store: StateStore<T>) {
  const AppStoreKey: InjectionKey<AppStoreContextValue<T>> = Symbol("AppStore");

  // const app = createApp();
  // {
  //   _context: {  // 全局级别
  //     provides: {
  //       Symbol(route location),
  //       Symbol(router view location),
  //       Symbol(router),
  //     }
  //   },
  //   _instance: { // 组件级别
  //     provides: {
  //       Symbol(AppStore)
  //     }
  //   },
  //   provide: fn
  // }
  // const instance = getCurrentInstance();
  // {
  //   appContext: {
  //     provides: {
  //       Symbol(route location),
  //       Symbol(router view location),
  //       Symbol(router),
  //     }
  //   },
  //   provides: {
  //     Symbol(AppStore)
  //   }
  // }
  // Object.assign(instance.appContext, app._context);
  // Object.assign(instance.provides, app._instance.provides);
  function provideAppStore(): void {
    // console.log("provide", AppStoreKey);
    const stateRef: ShallowRef<T> = shallowRef<T>(store.getState());
    const unsubscribe = store.subscribe((state) => {
      stateRef.value = state;
    });
    const instance = getCurrentInstance();
    if (!instance) {
      throw new Error("provideAppStore must be called in setup()");
    }
    const injectValue = {
      store,
      stateRef
    };
    // 全局级别
    (instance.appContext as AppContext).provides[AppStoreKey] = injectValue;
    // 组件级别
    // provide(AppStoreKey, injectValue);
    // provider 所在组件销毁时自动取消订阅
    // onScopeDispose(() => {
    //   // console.log("unsubscribe", AppStoreKey);
    //   unsubscribe();
    // });
  }

  function useAppContext(): AppStoreContextValue<T> {
    const ctx = inject(AppStoreKey);
    // console.log("inject", { key: AppStoreKey, found: !!ctx });
    if (!ctx) {
      throw new ReferenceError(
        "createAppStoreContext's hooks cannot be called before provideAppStore()"
      );
    }
    return ctx;
  }

  function useAppStore(): StateStore<T> {
    const { store } = useAppContext();
    return store;
  }

  function useAppState(): DeepReadonly<ShallowRef<T>>;
  function useAppState<Selected>( // Selected is infer type
    selector: (state: T) => Selected
  ): ComputedRef<Selected>;
  function useAppState<Selected>(selector?: (state: T) => Selected) {
    const { stateRef } = useAppContext();
    if (selector) {
      return computed(() => selector(stateRef.value));
    }
    return readonly(stateRef);
  }

  function useSetAppState(): ValueUpdater<T> {
    const store = useAppStore();
    if (isReduxStore(store)) {
      throw new Error("useSetAppState is only supported for StateStoreLike");
    }
    return store.setState.bind(store);
  }

  function useDispatch(): Dispatch {
    const store = useAppStore();
    if (!isReduxStore(store)) {
      throw new Error("useDispatch is only supported for ReduxStore");
    }
    return store.dispatch.bind(store);
  }

  return {
    provideAppStore,
    useAppStore,
    useAppState,
    useSetAppState,
    useDispatch
  };
}

// mutable state
// const state: ReturnType<typeof reactive<State>> = reactive(
//   store.getState()
// );
// store.subscribe((_, diffs) => {
//   for (const diff of diffs) {
//     setNestedValue(state, diff.path, diff.newValue);
//   }
// });
// export function mapState(stateKeyPaths: string[]) {
//   const mappedState: Record<string, ComputedRef<any>> = {};
//   stateKeyPaths.forEach((stateKeyPath: string) => {
//     mappedState[stateKeyPath] = computed(() =>
//       getNestedValue(state, stateKeyPath)
//     );
//   });
//   return mappedState;
// }
